import { FeeType } from 'types/graphql'

import FeeTemplateSelect from 'src/components/Selects/FeeTemplateSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  allowedTypes?: FeeType[]
  caption?: React.ReactNode
  field: TanstackField<number | null | undefined, TKey>
  isClearable?: boolean
  label?: React.ReactNode
}
const FeeTemplateSelectField = <TKey extends string>({
  allowedTypes,
  caption,
  field,
  isClearable,
  label,
}: Props<TKey>) => {
  return (
    <FeeTemplateSelect
      isMultiSelect={false}
      allowedTypes={allowedTypes}
      caption={caption}
      isClearable={isClearable}
      label={label}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default FeeTemplateSelectField
